import { createContext, useContext } from "react"
import { CachingService } from "../services/caching.service";

export const CachingServiceContext = createContext({} as CachingService);

export function useCachingService() {
    return useContext(CachingServiceContext);
}